<template>
  <li class="branch">
    <div class="ui radio">
      <span>
        <i
          v-if="checked[parseInt(branch.id_category, 10)]"
          class="check circle outline icon"
          @click="handleCheck(branch)"
        />
        <i v-else class="circle outline icon" @click="handleCheck(branch)" />
      </span>
      <label @click="toggleShowChildren">
        <span v-if="children">
          <i v-if="!showChildren" class="folder icon" />
          <i v-if="showChildren" class="folder open icon" />
        </span>
        {{ branch.id_category + '. ' + branch.name }}
      </label>
    </div>
    <ul v-if="children && showChildren" class="nested">
      <branch
        v-for="child in children"
        :key="child.id_category"
        :branch="child"
        :handle-check="handleCheck"
        :checked-category="checkedCategory"
      >
      </branch>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'Branch',
  props: {
    branch: {
      type: Object,
      default: null
    },
    checkedCategory: {
      type: Object,
      default: null
    },
    handleCheck: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showChildren: true,
      checked: {}
    }
  },
  computed: {
    children() {
      return this.branch.children ? Object.values(this.branch.children) : null
    }
  },
  watch: {
    checkedCategory(val) {
      const keys = Object.keys(this.checked)
      if (keys.length > 0) {
        keys.forEach((key) => {
          if (key === val.id_category) {
            this.$set(this.checked, val.id_category, true)
          } else {
            this.$set(this.checked, val.id_category, true)
            this.$set(this.checked, key, false)
          }
        })
      } else {
        this.$set(this.checked, val.id_category, true)
      }
    }
  },
  mounted() {
    if (this.checkedCategory) {
      this.$set(this.checked, this.checkedCategory.id_category, true)
    }
  },
  methods: {
    toggleShowChildren() {
      this.showChildren = !this.showChildren
    }
  }
}
</script>



// WEBPACK FOOTER //
// Branch.vue?7b43e28a